export const getImageUrl = (imageName) => `https://d3otrhxcw2ss5z.cloudfront.net/${imageName}`;
